// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"fe23ff26","268":"341c998b","517":"51366864","655":"943af7ab","745":"92801320","773":"a6832af5","915":"2eac1e3e"}[chunkId] + ".chunk.js";
};